import styled from 'styled-components';

import { Dropdown, Text } from '@gympass/yoga';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderSubLabel = styled(Text.H5)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const YearSelect = styled(Dropdown)`
  width: 106px;
  color: ${({ theme }) => theme.yoga.colors.primary};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.small}px;

  > div {
    border: none;
    background-color: transparent;
  }

  > ul {
    border: none;
    border-radius: ${({ theme }) => theme.yoga.radii.small}px;
    box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
    -ms-overflow-style: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    li {
      color: ${({ theme }) => theme.yoga.colors.inputDisabled};
      font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
    }
  }

  input {
    color: ${({ theme }) => theme.yoga.colors.primary};
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  }
`;
